export function getCurrencyLabel(currency: string): string {
  switch (currency) {
    case 'BRL':
      return 'R$ (BRL)';
    case 'USD':
      return '$ (USD)';
    case 'EUR':
      return '€ (EUR)';
    case 'GBP':
      return '£ (GBP)';
    case 'JPY':
      return '¥ (JPY)';
    case 'AUD':
      return 'A$ (AUD)';
    case 'CAD':
      return 'C$ (CAD)';
    case 'CHF':
      return 'Fr (CHF)';
    case 'CNY':
      return '¥ (CNY)';
    case 'HKD':
      return 'HK$ (HKD)';
    case 'NZD':
      return 'NZ$ (NZD)';
    case 'SEK':
      return 'kr (SEK)';
    case 'DKK':
      return 'kr (DKK)';
    case 'NOK':
      return 'kr (NOK)';
    case 'RUB':
      return '₽ (RUB)';
    case 'INR':
      return '₹ (INR)';
    case 'KRW':
      return '₩ (KRW)';
    case 'ZAR':
      return 'R (ZAR)';
    case 'PLN':
      return 'zł (PLN)';
    case 'ILS':
      return '₪ (ILS)';
    case 'PHP':
      return '₱ (PHP)';
    case 'SGD':
      return 'S$ (SGD)';
    case 'THB':
      return '฿ (THB)';
    case 'MXN':
      return '$ (MXN)';
    case 'MYR':
      return 'RM (MYR)';
    case 'TRY':
      return '₺ (TRY)';
    case 'IDR':
      return 'Rp (IDR)';
    case 'CZK':
      return 'Kč (CZK)';
    case 'HUF':
      return 'Ft (HUF)';
    case 'ISK':
      return 'kr (ISK)';
    case 'HRK':
      return 'kn (HRK)';
    case 'RON':
      return 'lei (RON)';
    case 'BGN':
      return 'лв (BGN)';
    default:
      return `(${currency})`;
  }
}

export enum Currency {
  BRL = 'BRL',
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
  JPY = 'JPY',
  AUD = 'AUD',
  CAD = 'CAD',
  CHF = 'CHF',
  CNY = 'CNY',
  HKD = 'HKD',
  NZD = 'NZD',
  SEK = 'SEK',
  DKK = 'DKK',
  NOK = 'NOK',
  RUB = 'RUB',
  INR = 'INR',
  KRW = 'KRW',
  ZAR = 'ZAR',
  PLN = 'PLN',
  ILS = 'ILS',
  PHP = 'PHP',
  SGD = 'SGD',
  THB = 'THB',
  MXN = 'MXN',
  MYR = 'MYR',
  TRY = 'TRY',
  IDR = 'IDR',
  CZK = 'CZK',
  HUF = 'HUF',
  ISK = 'ISK',
  HRK = 'HRK',
  RON = 'RON',
  BGN = 'BGN',
}

export const getCurrencyPrefix = (currency: Currency): string => {
  switch (currency) {
    case Currency.USD:
      return '$';
    case Currency.BRL:
      return 'R$';
    case Currency.EUR:
      return '€';
    case Currency.GBP:
      return '£';
    case Currency.JPY:
      return '¥';
    case Currency.AUD:
      return 'A$';
    case Currency.CAD:
      return 'C$';
    case Currency.CHF:
      return 'Fr';
    case Currency.CNY:
      return '¥';
    case Currency.HKD:
      return 'HK$';
    case Currency.NZD:
      return 'NZ$';
    case Currency.SEK:
      return 'kr';
    case Currency.DKK:
      return 'kr';
    case Currency.NOK:
      return 'kr';
    case Currency.RUB:
      return '₽';
    case Currency.INR:
      return '₹';
    case Currency.KRW:
      return '₩';
    case Currency.ZAR:
      return 'R';
    case Currency.PLN:
      return 'zł';
    case Currency.ILS:
      return '₪';
    case Currency.PHP:
      return '₱';
    case Currency.SGD:
      return 'S$';
    case Currency.THB:
      return '฿';
    case Currency.MXN:
      return '$';
    case Currency.MYR:
      return 'RM';
    case Currency.TRY:
      return '₺';
    case Currency.IDR:
      return 'Rp';
    case Currency.CZK:
      return 'Kč';
    case Currency.HUF:
      return 'Ft';
    case Currency.ISK:
      return 'kr';
    case Currency.HRK:
      return 'kn';
    case Currency.RON:
      return 'lei';
    case Currency.BGN:
      return 'лв';
    default:
      return '';
  }
};
